import script from "./ProductDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=080082d4&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080082d4"]])

export default __exports__